"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const core_1 = require("@material-ui/core");
const formik_1 = require("formik");
const RenderLocationField = (props) => {
    const { field: { value, name, onChange }, form: { errors }, label, placeholder, inputVariant, submitOnEnter, onInputBlur = () => undefined, ...otherProps } = props;
    const error = (0, formik_1.getIn)(errors, name);
    const onKeyDown = (event) => {
        if (!submitOnEnter) {
            if (event.key === 'Enter') {
                event.preventDefault();
            }
        }
    };
    const handleOnBlur = (event) => {
        const value = event.target.value.trim();
        onInputBlur(value);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.Box, null,
            react_1.default.createElement(core_1.Box, { marginBottom: "5px" },
                react_1.default.createElement(core_1.InputLabel, null, label)),
            react_1.default.createElement(core_1.TextField, { name: name, variant: inputVariant, fullWidth: true, error: !!error, value: value || '', placeholder: placeholder, onChange: onChange, onKeyDown: onKeyDown, onBlur: handleOnBlur, InputLabelProps: {
                    shrink: true,
                }, ...otherProps }),
            !!error && (react_1.default.createElement(core_1.Typography, { variant: "body2", component: "p", color: "error", ...otherProps }, error)))));
};
RenderLocationField.defaultProps = {
    inputVariant: 'filled',
    submitOnEnter: false,
};
RenderLocationField.propTypes = {
    field: prop_types_1.default.any.isRequired,
    form: prop_types_1.default.any.isRequired,
    label: prop_types_1.default.string.isRequired,
    placeholder: prop_types_1.default.string,
    submitOnEnter: prop_types_1.default.bool,
};
exports.default = RenderLocationField;
